import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
  UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  $serializer_getInstance33z4kgxgrgb0n as $serializer_getInstance,
  Cents1lsbs5l1tlgw as Cents,
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Cents__hashCode_impl_slsn8n2ym5pwri0ohtt as Cents__hashCode_impl_slsn8n,
  _Cents___init__impl__6gjhxu21pac6t02ivb3 as _Cents___init__impl__6gjhxu,
  Cents__minus_impl_j8lyu02ourtksxcdmf8 as Cents__minus_impl_j8lyu0,
  Cents__plus_impl_qsv4s83hvgnvnlu2892 as Cents__plus_impl_qsv4s8,
} from '../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  References31yy1vpluik8j as References,
  Index2tzg8vllut89f as Index,
  IndexUniqueness_UniqueNullSparse_getInstance15k4mz8ry6mov as IndexUniqueness_UniqueNullSparse_getInstance,
  Description1f0zycfwk0zld as Description,
  AdminTitleFields1r7jr8w0z0gjc as AdminTitleFields,
  AdminTableColumns127mx0x3shj3w as AdminTableColumns,
  NaturalSort21fbc8xpuy7g0 as NaturalSort,
  Denormalized13y861o5nekmb as Denormalized,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import {
  compareTo1g8l26b65emtd as compareTo,
  TypedIdexo9ecsepo30 as TypedId,
  HasId24qpfucecockd as HasId,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import {
  Grant2zfdfpt9q1mly as Grant,
  $serializer_getInstance2jfn7wtddihen as $serializer_getInstance_0,
  ID1lyj7m2ox8cp5 as ID,
  ID__toString_impl_y5cakawnw120meic4d as ID__toString_impl_y5caka,
  ID__hashCode_impl_f4lulzwl94qweqdore as ID__hashCode_impl_f4lulz,
  Employer27b20p5x27kte as Employer,
  $serializer_getInstance2m8ynx42p4oox as $serializer_getInstance_1,
  IDqqik72jjbpsn as ID_0,
  ID__toString_impl_y5caka2oopvpysxo85x as ID__toString_impl_y5caka_0,
  ID__hashCode_impl_f4lulzrhf9x0v3ec95 as ID__hashCode_impl_f4lulz_0,
  $serializer_getInstance27t66pok72ar9 as $serializer_getInstance_2,
  IDknm0szoty74n as ID_1,
  $serializer_getInstance1a39stva24llm as $serializer_getInstance_3,
  IDjecfjjw6mot9 as ID_2,
  $serializer_getInstance1dhvc4iof5db1 as $serializer_getInstance_4,
  ID1z61wlmtvxrjn as ID_3,
  $serializer_getInstance21thv1dv9fwx4 as $serializer_getInstance_5,
  ID1m87d1hextx54 as ID_4,
  ID__toString_impl_y5caka2gmrcvcxhykhn as ID__toString_impl_y5caka_1,
  ID__toString_impl_y5caka3samsckji65q8 as ID__toString_impl_y5caka_2,
  ID__toString_impl_y5caka34b933o3jkvt9 as ID__toString_impl_y5caka_3,
  ID__toString_impl_y5caka917l9wj8qah0 as ID__toString_impl_y5caka_4,
  ID__hashCode_impl_f4lulz1g9m782w6adsw as ID__hashCode_impl_f4lulz_1,
  ID__hashCode_impl_f4lulzhgc2u8u1q7v1 as ID__hashCode_impl_f4lulz_2,
  ID__hashCode_impl_f4lulz3s4hpwy6rxg06 as ID__hashCode_impl_f4lulz_3,
  ID__hashCode_impl_f4lulz1y71t598eu6qn as ID__hashCode_impl_f4lulz_4,
  CareProvider2qcawrqluyllr as CareProvider,
} from './domain.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  $serializer_getInstance2ga0n7x7no2vd as $serializer_getInstance_6,
  $serializer_getInstanceva225auct2k8 as $serializer_getInstance_7,
} from './types.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import {
  $serializer_getInstance38surg0wl5xyc as $serializer_getInstance_8,
  ID3lnbkn76l7dgd as ID_5,
  ID__toString_impl_y5caka1p73pxlcdvne as ID__toString_impl_y5caka_5,
  ID__hashCode_impl_f4lulz1p7uxb6gqsw7j as ID__hashCode_impl_f4lulz_5,
} from './careRates.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import {
  $serializer_getInstance3tvk07wc79lhi as $serializer_getInstance_9,
  Companion_getInstance27kcs909wdme9 as Companion_getInstance_0,
  Companion_getInstance1exe5oe9i5w84 as Companion_getInstance_1,
} from './attendance.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  mapOf2zpbbmyqk8xpf as mapOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_10();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.AccountingSyncInfo.LastSync', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('at', false);
        tmp0_serialDesc.addElement_5pzumi_k$('issue', true);
        tmp0_serialDesc.addElement_5pzumi_k$('shouldContinueSyncing', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_gi1116_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, InstantSerializer_getInstance(), value.at_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.issue_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, StringSerializer_getInstance(), value.issue_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.shouldContinueSyncing_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 2, value.shouldContinueSyncing_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_gi1116_k$(encoder, value instanceof LastSync() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, InstantSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, InstantSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return LastSync().new_org_thecommunitygroupinc_cares_AccountingSyncInfo_LastSync_2jm3g9_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [InstantSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_10() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var LastSyncClass;
function LastSync() {
  if (LastSyncClass === VOID) {
    class $ {
      constructor(at, issue, shouldContinueSyncing) {
        issue = issue === VOID ? null : issue;
        shouldContinueSyncing = shouldContinueSyncing === VOID ? true : shouldContinueSyncing;
        this.at_1 = at;
        this.issue_1 = issue;
        this.shouldContinueSyncing_1 = shouldContinueSyncing;
      }
      toString() {
        return 'LastSync(at=' + this.at_1.toString() + ', issue=' + this.issue_1 + ', shouldContinueSyncing=' + this.shouldContinueSyncing_1 + ')';
      }
      hashCode() {
        var result = this.at_1.hashCode();
        result = imul(result, 31) + (this.issue_1 == null ? 0 : getStringHashCode(this.issue_1)) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.shouldContinueSyncing_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LastSync()))
          return false;
        if (!this.at_1.equals(other.at_1))
          return false;
        if (!(this.issue_1 == other.issue_1))
          return false;
        if (!(this.shouldContinueSyncing_1 === other.shouldContinueSyncing_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_AccountingSyncInfo_LastSync_2jm3g9_k$(seen0, at, issue, shouldContinueSyncing, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_10().descriptor_1);
        }
        var $this = createThis(this);
        $this.at_1 = at;
        if (0 === (seen0 & 2))
          $this.issue_1 = null;
        else
          $this.issue_1 = issue;
        if (0 === (seen0 & 4))
          $this.shouldContinueSyncing_1 = true;
        else
          $this.shouldContinueSyncing_1 = shouldContinueSyncing;
        return $this;
      }
    }
    initMetadataForClass($, 'LastSync', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
    LastSyncClass = $;
  }
  return LastSyncClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_11();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.AccountingSyncInfo', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('lastSync', true);
        tmp0_serialDesc.addElement_5pzumi_k$('documentNumber', true);
        tmp0_serialDesc.addElement_5pzumi_k$('foreignId', true);
        tmp0_serialDesc.addElement_5pzumi_k$('reversedBy', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_9ewt2l_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.lastSync_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, $serializer_getInstance_10(), value.lastSync_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.documentNumber_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, StringSerializer_getInstance(), value.documentNumber_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.foreignId_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, StringSerializer_getInstance(), value.foreignId_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.reversedBy_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, StringSerializer_getInstance(), value.reversedBy_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_9ewt2l_k$(encoder, value instanceof AccountingSyncInfo() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AccountingSyncInfo().new_org_thecommunitygroupinc_cares_AccountingSyncInfo_hvguwh_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_10()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_11() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var AccountingSyncInfoClass;
function AccountingSyncInfo() {
  if (AccountingSyncInfoClass === VOID) {
    class $ {
      constructor(lastSync, documentNumber, foreignId, reversedBy) {
        lastSync = lastSync === VOID ? null : lastSync;
        documentNumber = documentNumber === VOID ? null : documentNumber;
        foreignId = foreignId === VOID ? null : foreignId;
        reversedBy = reversedBy === VOID ? null : reversedBy;
        this.lastSync_1 = lastSync;
        this.documentNumber_1 = documentNumber;
        this.foreignId_1 = foreignId;
        this.reversedBy_1 = reversedBy;
      }
      toString() {
        return 'AccountingSyncInfo(lastSync=' + toString_0(this.lastSync_1) + ', documentNumber=' + this.documentNumber_1 + ', foreignId=' + this.foreignId_1 + ', reversedBy=' + this.reversedBy_1 + ')';
      }
      hashCode() {
        var result = this.lastSync_1 == null ? 0 : this.lastSync_1.hashCode();
        result = imul(result, 31) + (this.documentNumber_1 == null ? 0 : getStringHashCode(this.documentNumber_1)) | 0;
        result = imul(result, 31) + (this.foreignId_1 == null ? 0 : getStringHashCode(this.foreignId_1)) | 0;
        result = imul(result, 31) + (this.reversedBy_1 == null ? 0 : getStringHashCode(this.reversedBy_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AccountingSyncInfo()))
          return false;
        if (!equals(this.lastSync_1, other.lastSync_1))
          return false;
        if (!(this.documentNumber_1 == other.documentNumber_1))
          return false;
        if (!(this.foreignId_1 == other.foreignId_1))
          return false;
        if (!(this.reversedBy_1 == other.reversedBy_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_AccountingSyncInfo_hvguwh_k$(seen0, lastSync, documentNumber, foreignId, reversedBy, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_11().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.lastSync_1 = null;
        else
          $this.lastSync_1 = lastSync;
        if (0 === (seen0 & 2))
          $this.documentNumber_1 = null;
        else
          $this.documentNumber_1 = documentNumber;
        if (0 === (seen0 & 4))
          $this.foreignId_1 = null;
        else
          $this.foreignId_1 = foreignId;
        if (0 === (seen0 & 8))
          $this.reversedBy_1 = null;
        else
          $this.reversedBy_1 = reversedBy;
        return $this;
      }
    }
    initMetadataForClass($, 'AccountingSyncInfo', AccountingSyncInfo, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
    AccountingSyncInfoClass = $;
  }
  return AccountingSyncInfoClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_12();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.AccountState', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('at', false);
        tmp0_serialDesc.addElement_5pzumi_k$('balance', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ed1m55_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, InstantSerializer_getInstance(), value.at_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), new (Cents())(value.balance_1));
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ed1m55_k$(encoder, value instanceof AccountState() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, InstantSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (Cents())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, InstantSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_2 = $serializer_getInstance();
                var tmp_3 = tmp5_local1;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (Cents())(tmp_3));
                tmp5_local1 = tmp_4 == null ? null : tmp_4.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AccountState().new_org_thecommunitygroupinc_cares_AccountState_oaywva_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [InstantSerializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_12() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var AccountStateClass;
function AccountState() {
  if (AccountStateClass === VOID) {
    class $ {
      constructor(at, balance) {
        this.at_1 = at;
        this.balance_1 = balance;
      }
      toString() {
        return 'AccountState(at=' + this.at_1.toString() + ', balance=' + Cents__toString_impl_ko5hxm(this.balance_1) + ')';
      }
      hashCode() {
        var result = this.at_1.hashCode();
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.balance_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AccountState()))
          return false;
        if (!this.at_1.equals(other.at_1))
          return false;
        if (!(this.balance_1 === other.balance_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_AccountState_oaywva_k$(seen0, at, balance, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_12().descriptor_1);
        }
        var $this = createThis(this);
        $this.at_1 = at;
        $this.balance_1 = balance;
        return $this;
      }
    }
    initMetadataForClass($, 'AccountState', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
    AccountStateClass = $;
  }
  return AccountStateClass;
}
function _ID___init__impl__k1lb7e(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5($this) {
  return $this;
}
function ID__toString_impl_y5caka_6($this) {
  return _ID___get_raw__impl__92g6u5($this).toString();
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_13();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_5() {
  return Companion_instance_3;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.GrantAccountTransaction.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(GrantAccountTransaction())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_pz2sf_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_pz2sf_k$(encoder, value instanceof ID_6() ? value.raw_1 : THROW_CCE());
      }
      deserialize_w9qo2g_k$(decoder) {
        return _ID___init__impl__k1lb7e(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_6())(this.deserialize_w9qo2g_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_13() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
function ID__hashCode_impl_f4lulz_6($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p($this, other) {
  if (!(other instanceof ID_6()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_6())(other instanceof ID_6() ? other.raw_1 : THROW_CCE()));
}
var IDClass;
function ID_6() {
  if (IDClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_6(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_6(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_13});
    IDClass = $;
  }
  return IDClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_14();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_6() {
  return Companion_instance_4;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.GrantAccountTransaction', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('grant', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (References())(getKClass(Grant())));
        tmp0_serialDesc.addElement_5pzumi_k$('amount', false);
        tmp0_serialDesc.addElement_5pzumi_k$('at', false);
        tmp0_serialDesc.addElement_5pzumi_k$('reason', false);
        tmp0_serialDesc.addElement_5pzumi_k$('pulledFrom', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())(IndexUniqueness_UniqueNullSparse_getInstance()));
        tmp0_serialDesc.addElement_5pzumi_k$('voided', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('When set, this transaction is revoked and excluded from reporting.'));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['at', 'amount']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['at', 'grant', 'amount', 'reason', 'voided']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-at']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_szu1dm_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_13(), new (ID_6())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_0(), new (ID())(value.grant_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance(), new (Cents())(value.amount_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, InstantSerializer_getInstance(), value.at_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 4, value.reason_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.pulledFrom_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, StringSerializer_getInstance(), value.pulledFrom_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.voided_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, $serializer_getInstance_6(), value.voided_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_szu1dm_k$(encoder, value instanceof GrantAccountTransaction() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_13();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_6())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_0();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_6(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_13();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID_6())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = $serializer_getInstance_0();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (ID())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_14 = $serializer_getInstance();
                var tmp_15 = tmp6_local2;
                var tmp_16 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_14, tmp_15 == null ? null : new (Cents())(tmp_15));
                tmp6_local2 = tmp_16 == null ? null : tmp_16.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_6(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return GrantAccountTransaction().new_org_thecommunitygroupinc_cares_GrantAccountTransaction_l5xsrz_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_13(), $serializer_getInstance_0(), $serializer_getInstance(), InstantSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_6())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_14() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var GrantAccountTransactionClass;
function GrantAccountTransaction() {
  if (GrantAccountTransactionClass === VOID) {
    class $ {
      constructor(_id, grant, amount, at, reason, pulledFrom, voided) {
        _id = _id === VOID ? _ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$()) : _id;
        pulledFrom = pulledFrom === VOID ? null : pulledFrom;
        voided = voided === VOID ? null : voided;
        this._id_1 = _id;
        this.grant_1 = grant;
        this.amount_1 = amount;
        this.at_1 = at;
        this.reason_1 = reason;
        this.pulledFrom_1 = pulledFrom;
        this.voided_1 = voided;
      }
      get__id_fvlwh1_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_6())(this.get__id_fvlwh1_k$());
      }
      toString() {
        return 'GrantAccountTransaction(_id=' + ID__toString_impl_y5caka_6(this._id_1) + ', grant=' + ID__toString_impl_y5caka(this.grant_1) + ', amount=' + Cents__toString_impl_ko5hxm(this.amount_1) + ', at=' + this.at_1.toString() + ', reason=' + this.reason_1 + ', pulledFrom=' + this.pulledFrom_1 + ', voided=' + toString_0(this.voided_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_6(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz(this.grant_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.amount_1) | 0;
        result = imul(result, 31) + this.at_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.reason_1) | 0;
        result = imul(result, 31) + (this.pulledFrom_1 == null ? 0 : getStringHashCode(this.pulledFrom_1)) | 0;
        result = imul(result, 31) + (this.voided_1 == null ? 0 : this.voided_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantAccountTransaction()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.grant_1, other.grant_1))
          return false;
        if (!(this.amount_1 === other.amount_1))
          return false;
        if (!this.at_1.equals(other.at_1))
          return false;
        if (!(this.reason_1 === other.reason_1))
          return false;
        if (!(this.pulledFrom_1 == other.pulledFrom_1))
          return false;
        if (!equals(this.voided_1, other.voided_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_GrantAccountTransaction_l5xsrz_k$(seen0, _id, grant, amount, at, reason, pulledFrom, voided, serializationConstructorMarker) {
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, $serializer_getInstance_14().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.grant_1 = grant;
        $this.amount_1 = amount;
        $this.at_1 = at;
        $this.reason_1 = reason;
        if (0 === (seen0 & 32))
          $this.pulledFrom_1 = null;
        else
          $this.pulledFrom_1 = pulledFrom;
        if (0 === (seen0 & 64))
          $this.voided_1 = null;
        else
          $this.voided_1 = voided;
        return $this;
      }
    }
    initMetadataForClass($, 'GrantAccountTransaction', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_14});
    GrantAccountTransactionClass = $;
  }
  return GrantAccountTransactionClass;
}
function _ID___init__impl__k1lb7e_0(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_0($this) {
  return $this;
}
function ID__toString_impl_y5caka_7($this) {
  return _ID___get_raw__impl__92g6u5_0($this).toString();
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_15();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_7() {
  return Companion_instance_5;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.EmployerAccountTransaction.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(EmployerAccountTransaction())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ciftm8_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_0(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ciftm8_k$(encoder, value instanceof ID_7() ? value.raw_1 : THROW_CCE());
      }
      deserialize_5looin_k$(decoder) {
        return _ID___init__impl__k1lb7e_0(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_7())(this.deserialize_5looin_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_15() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
function ID__hashCode_impl_f4lulz_7($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_0($this, other) {
  if (!(other instanceof ID_7()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_0($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_7())(other instanceof ID_7() ? other.raw_1 : THROW_CCE()));
}
var IDClass_0;
function ID_7() {
  if (IDClass_0 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_0(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_7(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_7(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_0(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_0(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_15});
    IDClass_0 = $;
  }
  return IDClass_0;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_16();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_8() {
  return Companion_instance_6;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.EmployerAccountTransaction', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('employer', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (References())(getKClass(Employer())));
        tmp0_serialDesc.addElement_5pzumi_k$('amount', false);
        tmp0_serialDesc.addElement_5pzumi_k$('at', false);
        tmp0_serialDesc.addElement_5pzumi_k$('reason', false);
        tmp0_serialDesc.addElement_5pzumi_k$('pulledFrom', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())(IndexUniqueness_UniqueNullSparse_getInstance()));
        tmp0_serialDesc.addElement_5pzumi_k$('voided', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('When set, this transaction is revoked and excluded from reporting.'));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['at', 'amount']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['at', 'employer', 'amount', 'reason', 'voided']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-at']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ndnlh1_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_0(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_15(), new (ID_7())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_1(), new (ID_0())(value.employer_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance(), new (Cents())(value.amount_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, InstantSerializer_getInstance(), value.at_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 4, value.reason_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.pulledFrom_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, StringSerializer_getInstance(), value.pulledFrom_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.voided_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, $serializer_getInstance_6(), value.voided_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ndnlh1_k$(encoder, value instanceof EmployerAccountTransaction() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_15();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_7())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_1();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_0())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_6(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_15();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID_7())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = $serializer_getInstance_1();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (ID_0())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_14 = $serializer_getInstance();
                var tmp_15 = tmp6_local2;
                var tmp_16 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_14, tmp_15 == null ? null : new (Cents())(tmp_15));
                tmp6_local2 = tmp_16 == null ? null : tmp_16.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_6(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return EmployerAccountTransaction().new_org_thecommunitygroupinc_cares_EmployerAccountTransaction_ejxsru_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_15(), $serializer_getInstance_1(), $serializer_getInstance(), InstantSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_6())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_16() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
var EmployerAccountTransactionClass;
function EmployerAccountTransaction() {
  if (EmployerAccountTransactionClass === VOID) {
    class $ {
      constructor(_id, employer, amount, at, reason, pulledFrom, voided) {
        _id = _id === VOID ? _ID___init__impl__k1lb7e_0(Companion_getInstance().random_fimq0t_k$()) : _id;
        pulledFrom = pulledFrom === VOID ? null : pulledFrom;
        voided = voided === VOID ? null : voided;
        this._id_1 = _id;
        this.employer_1 = employer;
        this.amount_1 = amount;
        this.at_1 = at;
        this.reason_1 = reason;
        this.pulledFrom_1 = pulledFrom;
        this.voided_1 = voided;
      }
      get__id_j2r05o_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_7())(this.get__id_j2r05o_k$());
      }
      toString() {
        return 'EmployerAccountTransaction(_id=' + ID__toString_impl_y5caka_7(this._id_1) + ', employer=' + ID__toString_impl_y5caka_0(this.employer_1) + ', amount=' + Cents__toString_impl_ko5hxm(this.amount_1) + ', at=' + this.at_1.toString() + ', reason=' + this.reason_1 + ', pulledFrom=' + this.pulledFrom_1 + ', voided=' + toString_0(this.voided_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_7(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_0(this.employer_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.amount_1) | 0;
        result = imul(result, 31) + this.at_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.reason_1) | 0;
        result = imul(result, 31) + (this.pulledFrom_1 == null ? 0 : getStringHashCode(this.pulledFrom_1)) | 0;
        result = imul(result, 31) + (this.voided_1 == null ? 0 : this.voided_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmployerAccountTransaction()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.employer_1, other.employer_1))
          return false;
        if (!(this.amount_1 === other.amount_1))
          return false;
        if (!this.at_1.equals(other.at_1))
          return false;
        if (!(this.reason_1 === other.reason_1))
          return false;
        if (!(this.pulledFrom_1 == other.pulledFrom_1))
          return false;
        if (!equals(this.voided_1, other.voided_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_EmployerAccountTransaction_ejxsru_k$(seen0, _id, employer, amount, at, reason, pulledFrom, voided, serializationConstructorMarker) {
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, $serializer_getInstance_16().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_0(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.employer_1 = employer;
        $this.amount_1 = amount;
        $this.at_1 = at;
        $this.reason_1 = reason;
        if (0 === (seen0 & 32))
          $this.pulledFrom_1 = null;
        else
          $this.pulledFrom_1 = pulledFrom;
        if (0 === (seen0 & 64))
          $this.voided_1 = null;
        else
          $this.voided_1 = voided;
        return $this;
      }
    }
    initMetadataForClass($, 'EmployerAccountTransaction', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_16});
    EmployerAccountTransactionClass = $;
  }
  return EmployerAccountTransactionClass;
}
function _ID___init__impl__k1lb7e_1(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_1($this) {
  return $this;
}
function ID__toString_impl_y5caka_8($this) {
  return _ID___get_raw__impl__92g6u5_1($this).toString();
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_17();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_7;
function Companion_getInstance_9() {
  return Companion_instance_7;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.CareProviderRemittance.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(CareProviderRemittance())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_84u338_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_1(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_84u338_k$(encoder, value instanceof ID_9() ? value.raw_1 : THROW_CCE());
      }
      deserialize_ubo80d_k$(decoder) {
        return _ID___init__impl__k1lb7e_1(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_9())(this.deserialize_ubo80d_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_17() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
function ID__hashCode_impl_f4lulz_8($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_1($this, other) {
  if (!(other instanceof ID_9()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_1($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_9())(other instanceof ID_9() ? other.raw_1 : THROW_CCE()));
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function CareProviderRemittance$PaymentStatus$Companion$_anonymous__k27pej() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.CareProviderRemittance.PaymentStatus', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  PaymentStatus_Prepared_instance = new (PaymentStatus())('Prepared', 0, 'Prepared');
  PaymentStatus_Issued_instance = new (PaymentStatus())('Issued', 1, 'Issued');
  PaymentStatus_Paid_instance = new (PaymentStatus())('Paid', 2, 'Paid');
  if (Companion_instance_8 === VOID) {
    Companion_instance;
    new (Companion_7())();
  }
}
var PaymentStatus_Prepared_instance;
var PaymentStatus_Issued_instance;
var PaymentStatus_Paid_instance;
function values() {
  static_init();
  return [PaymentStatus_Prepared_getInstance(), PaymentStatus_Issued_getInstance(), PaymentStatus_Paid_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, CareProviderRemittance$PaymentStatus$Companion$_anonymous__k27pej);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_8;
function Companion_getInstance_10() {
  static_init();
  return Companion_instance_8;
}
var $ENTRIES;
function _ID___init__impl__k1lb7e_2(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_2($this) {
  return $this;
}
function ID__toString_impl_y5caka_9($this) {
  return _ID___get_raw__impl__92g6u5_2($this).toString();
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_18();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_9;
function Companion_getInstance_11() {
  return Companion_instance_9;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.CareProviderRemittance.SingleChildDay.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(SingleChildDay())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_evj8ru_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_2(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_evj8ru_k$(encoder, value instanceof ID_8() ? value.raw_1 : THROW_CCE());
      }
      deserialize_xs45gv_k$(decoder) {
        return _ID___init__impl__k1lb7e_2(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_8())(this.deserialize_xs45gv_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_18() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
function ID__hashCode_impl_f4lulz_9($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_2($this, other) {
  if (!(other instanceof ID_8()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_2($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_8())(other instanceof ID_8() ? other.raw_1 : THROW_CCE()));
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_19();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_10;
function Companion_getInstance_12() {
  return Companion_instance_10;
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareProviderRemittance.SingleChildDay.GrantContribution', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('grant', false);
        tmp0_serialDesc.addElement_5pzumi_k$('amount', false);
        tmp0_serialDesc.addElement_5pzumi_k$('administrativeCharge', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_n359jt_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_0(), new (ID())(value.grant_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), new (Cents())(value.amount_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance(), new (Cents())(value.administrativeCharge_1));
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_n359jt_k$(encoder, value instanceof GrantContribution() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_0();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (Cents())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_0();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = $serializer_getInstance();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (Cents())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_14 = $serializer_getInstance();
                var tmp_15 = tmp6_local2;
                var tmp_16 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_14, tmp_15 == null ? null : new (Cents())(tmp_15));
                tmp6_local2 = tmp_16 == null ? null : tmp_16.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return GrantContribution().new_org_thecommunitygroupinc_cares_CareProviderRemittance_SingleChildDay_GrantContribution_oxaevs_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_0(), $serializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_19() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_20();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_11;
function Companion_getInstance_13() {
  return Companion_instance_11;
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareProviderRemittance.SingleChildDay.EmployerContribution', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('employer', false);
        tmp0_serialDesc.addElement_5pzumi_k$('amount', false);
        tmp0_serialDesc.addElement_5pzumi_k$('administrativeCharge', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_emhhco_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_1(), new (ID_0())(value.employer_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), new (Cents())(value.amount_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance(), new (Cents())(value.administrativeCharge_1));
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_emhhco_k$(encoder, value instanceof EmployerContribution() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_1();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_0())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (Cents())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_1();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID_0())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = $serializer_getInstance();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (Cents())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_14 = $serializer_getInstance();
                var tmp_15 = tmp6_local2;
                var tmp_16 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_14, tmp_15 == null ? null : new (Cents())(tmp_15));
                tmp6_local2 = tmp_16 == null ? null : tmp_16.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return EmployerContribution().new_org_thecommunitygroupinc_cares_CareProviderRemittance_SingleChildDay_EmployerContribution_oyzpf6_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_1(), $serializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_20() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
function CareProviderRemittance$SingleChildDay$Companion$$childSerializers$_anonymous__45939e() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_19());
}
function CareProviderRemittance$SingleChildDay$Companion$$childSerializers$_anonymous__45939e_0() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_20());
}
var IDClass_1;
function ID_8() {
  if (IDClass_1 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_2(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_9(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_9(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_2(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_2(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_18});
    IDClass_1 = $;
  }
  return IDClass_1;
}
var GrantContributionClass;
function GrantContribution() {
  if (GrantContributionClass === VOID) {
    class $ {
      constructor(grant, amount, administrativeCharge) {
        this.grant_1 = grant;
        this.amount_1 = amount;
        this.administrativeCharge_1 = administrativeCharge;
      }
      toString() {
        return 'GrantContribution(grant=' + ID__toString_impl_y5caka(this.grant_1) + ', amount=' + Cents__toString_impl_ko5hxm(this.amount_1) + ', administrativeCharge=' + Cents__toString_impl_ko5hxm(this.administrativeCharge_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz(this.grant_1);
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.amount_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.administrativeCharge_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantContribution()))
          return false;
        if (!equals(this.grant_1, other.grant_1))
          return false;
        if (!(this.amount_1 === other.amount_1))
          return false;
        if (!(this.administrativeCharge_1 === other.administrativeCharge_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareProviderRemittance_SingleChildDay_GrantContribution_oxaevs_k$(seen0, grant, amount, administrativeCharge, serializationConstructorMarker) {
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_19().descriptor_1);
        }
        var $this = createThis(this);
        $this.grant_1 = grant;
        $this.amount_1 = amount;
        $this.administrativeCharge_1 = administrativeCharge;
        return $this;
      }
    }
    initMetadataForClass($, 'GrantContribution', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
    GrantContributionClass = $;
  }
  return GrantContributionClass;
}
var EmployerContributionClass;
function EmployerContribution() {
  if (EmployerContributionClass === VOID) {
    class $ {
      constructor(employer, amount, administrativeCharge) {
        this.employer_1 = employer;
        this.amount_1 = amount;
        this.administrativeCharge_1 = administrativeCharge;
      }
      toString() {
        return 'EmployerContribution(employer=' + ID__toString_impl_y5caka_0(this.employer_1) + ', amount=' + Cents__toString_impl_ko5hxm(this.amount_1) + ', administrativeCharge=' + Cents__toString_impl_ko5hxm(this.administrativeCharge_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_0(this.employer_1);
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.amount_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.administrativeCharge_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmployerContribution()))
          return false;
        if (!equals(this.employer_1, other.employer_1))
          return false;
        if (!(this.amount_1 === other.amount_1))
          return false;
        if (!(this.administrativeCharge_1 === other.administrativeCharge_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareProviderRemittance_SingleChildDay_EmployerContribution_oyzpf6_k$(seen0, employer, amount, administrativeCharge, serializationConstructorMarker) {
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_20().descriptor_1);
        }
        var $this = createThis(this);
        $this.employer_1 = employer;
        $this.amount_1 = amount;
        $this.administrativeCharge_1 = administrativeCharge;
        return $this;
      }
    }
    initMetadataForClass($, 'EmployerContribution', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
    EmployerContributionClass = $;
  }
  return EmployerContributionClass;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      constructor() {
        Companion_instance_12 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, CareProviderRemittance$SingleChildDay$Companion$$childSerializers$_anonymous__45939e);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, null, null, null, null, null, tmp_1, lazy(tmp_2, CareProviderRemittance$SingleChildDay$Companion$$childSerializers$_anonymous__45939e_0), null, null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_21();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_12;
function Companion_getInstance_14() {
  if (Companion_instance_12 === VOID)
    new (Companion_11())();
  return Companion_instance_12;
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareProviderRemittance.SingleChildDay', this, 15);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('remittance', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('placement', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('family', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('location', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('program', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())("The program the day was billed at: the intermittent one when the child's school was out."));
        tmp0_serialDesc.addElement_5pzumi_k$('forDate', false);
        tmp0_serialDesc.addElement_5pzumi_k$('price', false);
        tmp0_serialDesc.addElement_5pzumi_k$('grantContributions', false);
        tmp0_serialDesc.addElement_5pzumi_k$('employerContributions', false);
        tmp0_serialDesc.addElement_5pzumi_k$('totalContributions', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('paidByFamily', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('attendance', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('voided', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['forDate', 'price']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['forDate', 'placement', 'price', 'totalContributions', 'paidByFamily', 'voided']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-forDate']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_rwin8x_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_14().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_2(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_18(), new (ID_8())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_17(), new (ID_9())(value.remittance_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_2(), new (ID_1())(value.placement_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, $serializer_getInstance_3(), new (ID_2())(value.family_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, $serializer_getInstance_4(), new (ID_3())(value.location_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, $serializer_getInstance_5(), new (ID_4())(value.provider_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, $serializer_getInstance_8(), new (ID_5())(value.program_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 7, LocalDateSerializer_getInstance(), value.forDate_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 8, $serializer_getInstance(), new (Cents())(value.price_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 9, tmp2_cached[9].get_value_j01efc_k$(), value.grantContributions_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 10, tmp2_cached[10].get_value_j01efc_k$(), value.employerContributions_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 11, $serializer_getInstance(), new (Cents())(value.totalContributions_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 12, $serializer_getInstance(), new (Cents())(value.paidByFamily_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 13) ? true : !value.attendance_1.equals(Companion_getInstance_0().PLACEHOLDER_1)) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 13, $serializer_getInstance_9(), value.attendance_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 14) ? true : !(value.voided_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 14, $serializer_getInstance_6(), value.voided_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_rwin8x_k$(encoder, value instanceof SingleChildDay() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp20_cached = Companion_getInstance_14().$childSerializers_1;
        if (tmp19_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_18();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_8())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_17();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_9())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (ID_1())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_8 = $serializer_getInstance_3();
          var tmp_9 = tmp7_local3;
          var tmp_10 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new (ID_2())(tmp_9));
          tmp7_local3 = tmp_10 == null ? null : tmp_10.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_11 = $serializer_getInstance_4();
          var tmp_12 = tmp8_local4;
          var tmp_13 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_11, tmp_12 == null ? null : new (ID_3())(tmp_12));
          tmp8_local4 = tmp_13 == null ? null : tmp_13.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_14 = $serializer_getInstance_5();
          var tmp_15 = tmp9_local5;
          var tmp_16 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp_14, tmp_15 == null ? null : new (ID_4())(tmp_15));
          tmp9_local5 = tmp_16 == null ? null : tmp_16.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_17 = $serializer_getInstance_8();
          var tmp_18 = tmp10_local6;
          var tmp_19 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp_17, tmp_18 == null ? null : new (ID_5())(tmp_18));
          tmp10_local6 = tmp_19 == null ? null : tmp_19.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, LocalDateSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          var tmp_20 = $serializer_getInstance();
          var tmp_21 = tmp12_local8;
          var tmp_22 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, tmp_20, tmp_21 == null ? null : new (Cents())(tmp_21));
          tmp12_local8 = tmp_22 == null ? null : tmp_22.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, tmp20_cached[9].get_value_j01efc_k$(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 10, tmp20_cached[10].get_value_j01efc_k$(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          var tmp_23 = $serializer_getInstance();
          var tmp_24 = tmp15_local11;
          var tmp_25 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 11, tmp_23, tmp_24 == null ? null : new (Cents())(tmp_24));
          tmp15_local11 = tmp_25 == null ? null : tmp_25.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          var tmp_26 = $serializer_getInstance();
          var tmp_27 = tmp16_local12;
          var tmp_28 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 12, tmp_26, tmp_27 == null ? null : new (Cents())(tmp_27));
          tmp16_local12 = tmp_28 == null ? null : tmp_28.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 13, $serializer_getInstance_9(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp19_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 14, $serializer_getInstance_6(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp19_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_29 = $serializer_getInstance_18();
                var tmp_30 = tmp4_local0;
                var tmp_31 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_29, tmp_30 == null ? null : new (ID_8())(tmp_30));
                tmp4_local0 = tmp_31 == null ? null : tmp_31.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_32 = $serializer_getInstance_17();
                var tmp_33 = tmp5_local1;
                var tmp_34 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_32, tmp_33 == null ? null : new (ID_9())(tmp_33));
                tmp5_local1 = tmp_34 == null ? null : tmp_34.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_35 = $serializer_getInstance_2();
                var tmp_36 = tmp6_local2;
                var tmp_37 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_35, tmp_36 == null ? null : new (ID_1())(tmp_36));
                tmp6_local2 = tmp_37 == null ? null : tmp_37.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_38 = $serializer_getInstance_3();
                var tmp_39 = tmp7_local3;
                var tmp_40 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_38, tmp_39 == null ? null : new (ID_2())(tmp_39));
                tmp7_local3 = tmp_40 == null ? null : tmp_40.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_41 = $serializer_getInstance_4();
                var tmp_42 = tmp8_local4;
                var tmp_43 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_41, tmp_42 == null ? null : new (ID_3())(tmp_42));
                tmp8_local4 = tmp_43 == null ? null : tmp_43.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_44 = $serializer_getInstance_5();
                var tmp_45 = tmp9_local5;
                var tmp_46 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp_44, tmp_45 == null ? null : new (ID_4())(tmp_45));
                tmp9_local5 = tmp_46 == null ? null : tmp_46.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_47 = $serializer_getInstance_8();
                var tmp_48 = tmp10_local6;
                var tmp_49 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp_47, tmp_48 == null ? null : new (ID_5())(tmp_48));
                tmp10_local6 = tmp_49 == null ? null : tmp_49.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, LocalDateSerializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                var tmp_50 = $serializer_getInstance();
                var tmp_51 = tmp12_local8;
                var tmp_52 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, tmp_50, tmp_51 == null ? null : new (Cents())(tmp_51));
                tmp12_local8 = tmp_52 == null ? null : tmp_52.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, tmp20_cached[9].get_value_j01efc_k$(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 10, tmp20_cached[10].get_value_j01efc_k$(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                var tmp_53 = $serializer_getInstance();
                var tmp_54 = tmp15_local11;
                var tmp_55 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 11, tmp_53, tmp_54 == null ? null : new (Cents())(tmp_54));
                tmp15_local11 = tmp_55 == null ? null : tmp_55.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                var tmp_56 = $serializer_getInstance();
                var tmp_57 = tmp16_local12;
                var tmp_58 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 12, tmp_56, tmp_57 == null ? null : new (Cents())(tmp_57));
                tmp16_local12 = tmp_58 == null ? null : tmp_58.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp19_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 13, $serializer_getInstance_9(), tmp17_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp19_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 14, $serializer_getInstance_6(), tmp18_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp19_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SingleChildDay().new_org_thecommunitygroupinc_cares_CareProviderRemittance_SingleChildDay_3mbz3y_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_14().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_18(), $serializer_getInstance_17(), $serializer_getInstance_2(), $serializer_getInstance_3(), $serializer_getInstance_4(), $serializer_getInstance_5(), $serializer_getInstance_8(), LocalDateSerializer_getInstance(), $serializer_getInstance(), tmp0_cached[9].get_value_j01efc_k$(), tmp0_cached[10].get_value_j01efc_k$(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance_9(), get_nullable($serializer_getInstance_6())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_21() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
function CareProviderRemittance$Companion$$childSerializers$_anonymous__shr00a() {
  return Companion_getInstance_10().serializer_9w0wvi_k$();
}
var IDClass_2;
function ID_9() {
  if (IDClass_2 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_1(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_8(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_8(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_1(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_1(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_17});
    IDClass_2 = $;
  }
  return IDClass_2;
}
var PaymentStatusClass;
function PaymentStatus() {
  if (PaymentStatusClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'PaymentStatus', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_10});
    PaymentStatusClass = $;
  }
  return PaymentStatusClass;
}
var SingleChildDayClass;
function SingleChildDay() {
  if (SingleChildDayClass === VOID) {
    class $ {
      constructor(_id, remittance, placement, family, location, provider, program, forDate, price, grantContributions, employerContributions, totalContributions, paidByFamily, attendance, voided) {
        Companion_getInstance_14();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_2(Companion_getInstance().random_fimq0t_k$()) : _id;
        attendance = attendance === VOID ? Companion_getInstance_0().PLACEHOLDER_1 : attendance;
        voided = voided === VOID ? null : voided;
        this._id_1 = _id;
        this.remittance_1 = remittance;
        this.placement_1 = placement;
        this.family_1 = family;
        this.location_1 = location;
        this.provider_1 = provider;
        this.program_1 = program;
        this.forDate_1 = forDate;
        this.price_1 = price;
        this.grantContributions_1 = grantContributions;
        this.employerContributions_1 = employerContributions;
        this.totalContributions_1 = totalContributions;
        this.paidByFamily_1 = paidByFamily;
        this.attendance_1 = attendance;
        this.voided_1 = voided;
      }
      get__id_ofnhs4_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_8())(this.get__id_ofnhs4_k$());
      }
      toString() {
        return 'SingleChildDay(_id=' + ID__toString_impl_y5caka_9(this._id_1) + ', remittance=' + ID__toString_impl_y5caka_8(this.remittance_1) + ', placement=' + ID__toString_impl_y5caka_1(this.placement_1) + ', family=' + ID__toString_impl_y5caka_2(this.family_1) + ', location=' + ID__toString_impl_y5caka_3(this.location_1) + ', provider=' + ID__toString_impl_y5caka_4(this.provider_1) + ', program=' + ID__toString_impl_y5caka_5(this.program_1) + ', forDate=' + this.forDate_1.toString() + ', price=' + Cents__toString_impl_ko5hxm(this.price_1) + ', grantContributions=' + toString(this.grantContributions_1) + ', employerContributions=' + toString(this.employerContributions_1) + ', totalContributions=' + Cents__toString_impl_ko5hxm(this.totalContributions_1) + ', paidByFamily=' + Cents__toString_impl_ko5hxm(this.paidByFamily_1) + ', attendance=' + this.attendance_1.toString() + ', voided=' + toString_0(this.voided_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_9(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_8(this.remittance_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_1(this.placement_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_2(this.family_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_3(this.location_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_4(this.provider_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_5(this.program_1) | 0;
        result = imul(result, 31) + this.forDate_1.hashCode() | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.price_1) | 0;
        result = imul(result, 31) + hashCode(this.grantContributions_1) | 0;
        result = imul(result, 31) + hashCode(this.employerContributions_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.totalContributions_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.paidByFamily_1) | 0;
        result = imul(result, 31) + this.attendance_1.hashCode() | 0;
        result = imul(result, 31) + (this.voided_1 == null ? 0 : this.voided_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SingleChildDay()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.remittance_1, other.remittance_1))
          return false;
        if (!equals(this.placement_1, other.placement_1))
          return false;
        if (!equals(this.family_1, other.family_1))
          return false;
        if (!equals(this.location_1, other.location_1))
          return false;
        if (!equals(this.provider_1, other.provider_1))
          return false;
        if (!equals(this.program_1, other.program_1))
          return false;
        if (!this.forDate_1.equals(other.forDate_1))
          return false;
        if (!(this.price_1 === other.price_1))
          return false;
        if (!equals(this.grantContributions_1, other.grantContributions_1))
          return false;
        if (!equals(this.employerContributions_1, other.employerContributions_1))
          return false;
        if (!(this.totalContributions_1 === other.totalContributions_1))
          return false;
        if (!(this.paidByFamily_1 === other.paidByFamily_1))
          return false;
        if (!this.attendance_1.equals(other.attendance_1))
          return false;
        if (!equals(this.voided_1, other.voided_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareProviderRemittance_SingleChildDay_3mbz3y_k$(seen0, _id, remittance, placement, family, location, provider, program, forDate, price, grantContributions, employerContributions, totalContributions, paidByFamily, attendance, voided, serializationConstructorMarker) {
        Companion_getInstance_14();
        if (!(8190 === (8190 & seen0))) {
          throwMissingFieldException(seen0, 8190, $serializer_getInstance_21().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_2(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.remittance_1 = remittance;
        $this.placement_1 = placement;
        $this.family_1 = family;
        $this.location_1 = location;
        $this.provider_1 = provider;
        $this.program_1 = program;
        $this.forDate_1 = forDate;
        $this.price_1 = price;
        $this.grantContributions_1 = grantContributions;
        $this.employerContributions_1 = employerContributions;
        $this.totalContributions_1 = totalContributions;
        $this.paidByFamily_1 = paidByFamily;
        if (0 === (seen0 & 8192))
          $this.attendance_1 = Companion_getInstance_0().PLACEHOLDER_1;
        else
          $this.attendance_1 = attendance;
        if (0 === (seen0 & 16384))
          $this.voided_1 = null;
        else
          $this.voided_1 = voided;
        return $this;
      }
    }
    initMetadataForClass($, 'SingleChildDay', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_21});
    SingleChildDayClass = $;
  }
  return SingleChildDayClass;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      constructor() {
        Companion_instance_13 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, null, lazy(tmp_0, CareProviderRemittance$Companion$$childSerializers$_anonymous__shr00a), null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_22();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_13;
function Companion_getInstance_15() {
  if (Companion_instance_13 === VOID)
    new (Companion_12())();
  return Companion_instance_13;
}
var $serializerClass_11;
function $serializer_11() {
  if ($serializerClass_11 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_11 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareProviderRemittance', this, 8);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (References())(getKClass(CareProvider())));
        tmp0_serialDesc.addElement_5pzumi_k$('forDates', false);
        tmp0_serialDesc.addElement_5pzumi_k$('at', true);
        tmp0_serialDesc.addElement_5pzumi_k$('amount', false);
        tmp0_serialDesc.addElement_5pzumi_k$('status', true);
        tmp0_serialDesc.addElement_5pzumi_k$('voided', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('When set, this remittance is revoked and excluded from reporting.'));
        tmp0_serialDesc.addElement_5pzumi_k$('sync', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['forDates.start', 'amount']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['forDates.start', 'forDates.endInclusive', 'provider', 'amount', 'status', 'voided']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-forDates.start']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_c8alhl_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_15().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_1(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_17(), new (ID_9())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_5(), new (ID_4())(value.provider_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_7(), value.forDates_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.at_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), value.at_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, $serializer_getInstance(), new (Cents())(value.amount_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.status_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, tmp2_cached[5].get_value_j01efc_k$(), value.status_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.voided_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, $serializer_getInstance_6(), value.voided_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !(value.sync_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 7, $serializer_getInstance_11(), value.sync_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_c8alhl_k$(encoder, value instanceof CareProviderRemittance() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp13_cached = Companion_getInstance_15().$childSerializers_1;
        if (tmp12_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_17();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_9())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_5();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_4())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_7(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_5 = $serializer_getInstance();
          var tmp_6 = tmp8_local4;
          var tmp_7 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
          tmp8_local4 = tmp_7 == null ? null : tmp_7.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, tmp13_cached[5].get_value_j01efc_k$(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_6(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, $serializer_getInstance_11(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_17();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID_9())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = $serializer_getInstance_5();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (ID_4())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_7(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_14 = $serializer_getInstance();
                var tmp_15 = tmp8_local4;
                var tmp_16 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_14, tmp_15 == null ? null : new (Cents())(tmp_15));
                tmp8_local4 = tmp_16 == null ? null : tmp_16.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, tmp13_cached[5].get_value_j01efc_k$(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_6(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, $serializer_getInstance_11(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp12_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareProviderRemittance().new_org_thecommunitygroupinc_cares_CareProviderRemittance_se4oqe_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_15().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_17(), $serializer_getInstance_5(), $serializer_getInstance_7(), get_nullable(InstantSerializer_getInstance()), $serializer_getInstance(), get_nullable(tmp0_cached[5].get_value_j01efc_k$()), get_nullable($serializer_getInstance_6()), get_nullable($serializer_getInstance_11())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_11 = $;
  }
  return $serializerClass_11;
}
var $serializer_instance_11;
function $serializer_getInstance_22() {
  if ($serializer_instance_11 === VOID)
    new ($serializer_11())();
  return $serializer_instance_11;
}
function PaymentStatus_Prepared_getInstance() {
  static_init();
  return PaymentStatus_Prepared_instance;
}
function PaymentStatus_Issued_getInstance() {
  static_init();
  return PaymentStatus_Issued_instance;
}
function PaymentStatus_Paid_getInstance() {
  static_init();
  return PaymentStatus_Paid_instance;
}
var CareProviderRemittanceClass;
function CareProviderRemittance() {
  if (CareProviderRemittanceClass === VOID) {
    class $ {
      constructor(_id, provider, forDates, at, amount, status, voided, sync) {
        Companion_getInstance_15();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_1(Companion_getInstance().random_fimq0t_k$()) : _id;
        at = at === VOID ? null : at;
        status = status === VOID ? null : status;
        voided = voided === VOID ? null : voided;
        sync = sync === VOID ? null : sync;
        this._id_1 = _id;
        this.provider_1 = provider;
        this.forDates_1 = forDates;
        this.at_1 = at;
        this.amount_1 = amount;
        this.status_1 = status;
        this.voided_1 = voided;
        this.sync_1 = sync;
      }
      get__id_6v5w80_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_9())(this.get__id_6v5w80_k$());
      }
      toString() {
        return 'CareProviderRemittance(_id=' + ID__toString_impl_y5caka_8(this._id_1) + ', provider=' + ID__toString_impl_y5caka_4(this.provider_1) + ', forDates=' + this.forDates_1.toString() + ', at=' + toString_0(this.at_1) + ', amount=' + Cents__toString_impl_ko5hxm(this.amount_1) + ', status=' + toString_0(this.status_1) + ', voided=' + toString_0(this.voided_1) + ', sync=' + toString_0(this.sync_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_8(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_4(this.provider_1) | 0;
        result = imul(result, 31) + this.forDates_1.hashCode() | 0;
        result = imul(result, 31) + (this.at_1 == null ? 0 : this.at_1.hashCode()) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.amount_1) | 0;
        result = imul(result, 31) + (this.status_1 == null ? 0 : this.status_1.hashCode()) | 0;
        result = imul(result, 31) + (this.voided_1 == null ? 0 : this.voided_1.hashCode()) | 0;
        result = imul(result, 31) + (this.sync_1 == null ? 0 : this.sync_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareProviderRemittance()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.provider_1, other.provider_1))
          return false;
        if (!this.forDates_1.equals(other.forDates_1))
          return false;
        if (!equals(this.at_1, other.at_1))
          return false;
        if (!(this.amount_1 === other.amount_1))
          return false;
        if (!equals(this.status_1, other.status_1))
          return false;
        if (!equals(this.voided_1, other.voided_1))
          return false;
        if (!equals(this.sync_1, other.sync_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareProviderRemittance_se4oqe_k$(seen0, _id, provider, forDates, at, amount, status, voided, sync, serializationConstructorMarker) {
        Companion_getInstance_15();
        if (!(22 === (22 & seen0))) {
          throwMissingFieldException(seen0, 22, $serializer_getInstance_22().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_1(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.provider_1 = provider;
        $this.forDates_1 = forDates;
        if (0 === (seen0 & 8))
          $this.at_1 = null;
        else
          $this.at_1 = at;
        $this.amount_1 = amount;
        if (0 === (seen0 & 32))
          $this.status_1 = null;
        else
          $this.status_1 = status;
        if (0 === (seen0 & 64))
          $this.voided_1 = null;
        else
          $this.voided_1 = voided;
        if (0 === (seen0 & 128))
          $this.sync_1 = null;
        else
          $this.sync_1 = sync;
        return $this;
      }
    }
    initMetadataForClass($, 'CareProviderRemittance', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_22});
    CareProviderRemittanceClass = $;
  }
  return CareProviderRemittanceClass;
}
function ProposedRemittance$Companion$$childSerializers$_anonymous__7cixyy() {
  return new (ArrayListSerializer())($serializer_getInstance_21());
}
function ProposedRemittance$Companion$$childSerializers$_anonymous__7cixyy_0() {
  return new (ArrayListSerializer())($serializer_getInstance_27());
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      constructor() {
        Companion_instance_14 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProposedRemittance$Companion$$childSerializers$_anonymous__7cixyy);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, tmp_1, lazy(tmp_2, ProposedRemittance$Companion$$childSerializers$_anonymous__7cixyy_0)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_23();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_14;
function Companion_getInstance_16() {
  if (Companion_instance_14 === VOID)
    new (Companion_13())();
  return Companion_instance_14;
}
var $serializerClass_12;
function $serializer_12() {
  if ($serializerClass_12 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_12 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ProposedRemittance', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('remittance', false);
        tmp0_serialDesc.addElement_5pzumi_k$('days', false);
        tmp0_serialDesc.addElement_5pzumi_k$('problems', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_i1f0rd_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_16().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_22(), value.remittance_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.days_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.problems_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_i1f0rd_k$(encoder, value instanceof ProposedRemittance() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp8_cached = Companion_getInstance_16().$childSerializers_1;
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp8_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp8_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ProposedRemittance().new_org_thecommunitygroupinc_cares_ProposedRemittance_tn0m1s_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_16().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_22(), tmp0_cached[1].get_value_j01efc_k$(), tmp0_cached[2].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_12 = $;
  }
  return $serializerClass_12;
}
var $serializer_instance_12;
function $serializer_getInstance_23() {
  if ($serializer_instance_12 === VOID)
    new ($serializer_12())();
  return $serializer_instance_12;
}
var ProposedRemittanceClass;
function ProposedRemittance() {
  if (ProposedRemittanceClass === VOID) {
    class $ {
      constructor(remittance, days, problems) {
        Companion_getInstance_16();
        this.remittance_1 = remittance;
        this.days_1 = days;
        this.problems_1 = problems;
      }
      toString() {
        return 'ProposedRemittance(remittance=' + this.remittance_1.toString() + ', days=' + toString(this.days_1) + ', problems=' + toString(this.problems_1) + ')';
      }
      hashCode() {
        var result = this.remittance_1.hashCode();
        result = imul(result, 31) + hashCode(this.days_1) | 0;
        result = imul(result, 31) + hashCode(this.problems_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProposedRemittance()))
          return false;
        if (!this.remittance_1.equals(other.remittance_1))
          return false;
        if (!equals(this.days_1, other.days_1))
          return false;
        if (!equals(this.problems_1, other.problems_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ProposedRemittance_tn0m1s_k$(seen0, remittance, days, problems, serializationConstructorMarker) {
        Companion_getInstance_16();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_23().descriptor_1);
        }
        var $this = createThis(this);
        $this.remittance_1 = remittance;
        $this.days_1 = days;
        $this.problems_1 = problems;
        return $this;
      }
    }
    initMetadataForClass($, 'ProposedRemittance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
    ProposedRemittanceClass = $;
  }
  return ProposedRemittanceClass;
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_24();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_15;
function Companion_getInstance_17() {
  return Companion_instance_15;
}
var $serializerClass_13;
function $serializer_13() {
  if ($serializerClass_13 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_13 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ProviderPeriod', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.addElement_5pzumi_k$('forDates', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_qkt2o7_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_5(), new (ID_4())(value.provider_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_7(), value.forDates_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_qkt2o7_k$(encoder, value instanceof ProviderPeriod() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_5();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_4())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_5();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_4())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ProviderPeriod().new_org_thecommunitygroupinc_cares_ProviderPeriod_8sax6m_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_5(), $serializer_getInstance_7()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_13 = $;
  }
  return $serializerClass_13;
}
var $serializer_instance_13;
function $serializer_getInstance_24() {
  if ($serializer_instance_13 === VOID)
    new ($serializer_13())();
  return $serializer_instance_13;
}
var ProviderPeriodClass;
function ProviderPeriod() {
  if (ProviderPeriodClass === VOID) {
    class $ {
      constructor(provider, forDates) {
        this.provider_1 = provider;
        this.forDates_1 = forDates;
      }
      toString() {
        return 'ProviderPeriod(provider=' + ID__toString_impl_y5caka_4(this.provider_1) + ', forDates=' + this.forDates_1.toString() + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_4(this.provider_1);
        result = imul(result, 31) + this.forDates_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProviderPeriod()))
          return false;
        if (!equals(this.provider_1, other.provider_1))
          return false;
        if (!this.forDates_1.equals(other.forDates_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ProviderPeriod_8sax6m_k$(seen0, provider, forDates, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_24().descriptor_1);
        }
        var $this = createThis(this);
        $this.provider_1 = provider;
        $this.forDates_1 = forDates;
        return $this;
      }
    }
    initMetadataForClass($, 'ProviderPeriod', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
    ProviderPeriodClass = $;
  }
  return ProviderPeriodClass;
}
function BilledDayTotals$Companion$$childSerializers$_anonymous__mtg9c5() {
  return new (LinkedHashMapSerializer())($serializer_getInstance_1(), $serializer_getInstance_26());
}
function BilledDayTotals$Companion$$childSerializers$_anonymous__mtg9c5_0() {
  return new (LinkedHashMapSerializer())($serializer_getInstance_0(), $serializer_getInstance_26());
}
function BilledDayTotals$Companion$$childSerializers$_anonymous__mtg9c5_1() {
  return new (LinkedHashMapSerializer())(Companion_getInstance_1().serializer_9w0wvi_k$(), IntSerializer_getInstance());
}
function BilledDayTotals$Companion$$childSerializers$_anonymous__mtg9c5_2() {
  return new (LinkedHashMapSerializer())(Companion_getInstance_1().serializer_9w0wvi_k$(), IntSerializer_getInstance());
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      constructor() {
        Companion_instance_16 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, BilledDayTotals$Companion$$childSerializers$_anonymous__mtg9c5);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, BilledDayTotals$Companion$$childSerializers$_anonymous__mtg9c5_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, BilledDayTotals$Companion$$childSerializers$_anonymous__mtg9c5_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, tmp_1, tmp_3, tmp_5, lazy(tmp_6, BilledDayTotals$Companion$$childSerializers$_anonymous__mtg9c5_2), null, null, null, null];
      }
      of_qaxhqt_k$(day) {
        var attendance = day.attendance_1;
        var wholeDayAbsence = !(attendance.case_1.explained_1 == null) && !attendance.case_1.atLeastPartialAttendance_1;
        // Inline function 'kotlin.collections.associate' call
        var this_0 = day.employerContributions_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair = to(new (ID_0())(element.employer_1), new (PayerTotal())(1, element.amount_1, element.administrativeCharge_1));
          destination.put_4fpzoq_k$(pair.first_1, pair.second_1);
        }
        var tmp = destination;
        // Inline function 'kotlin.collections.associate' call
        var this_1 = day.grantContributions_1;
        var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_0);
        var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair_0 = to(new (ID())(element_0.grant_1), new (PayerTotal())(1, element_0.amount_1, element_0.administrativeCharge_1));
          destination_0.put_4fpzoq_k$(pair_0.first_1, pair_0.second_1);
        }
        var tmp_0 = destination_0;
        var tmp_1;
        if (attendance.useIntermittent_1) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp_1 = emptyMap();
        } else {
          tmp_1 = mapOf(to(attendance.get_billedTime_8fk3ac_k$(), 1));
        }
        var tmp_2 = tmp_1;
        var tmp_3;
        if (attendance.useIntermittent_1) {
          tmp_3 = mapOf(to(attendance.get_billedTime_8fk3ac_k$(), 1));
        } else {
          // Inline function 'kotlin.collections.mapOf' call
          tmp_3 = emptyMap();
        }
        return new (BilledDayTotals())(1, day.price_1, day.paidByFamily_1, tmp, tmp_0, tmp_2, tmp_3, attendance.get_transportCount_67vxxt_k$() === 1 ? 1 : 0, attendance.get_transportCount_67vxxt_k$() === 2 ? 1 : 0, wholeDayAbsence && attendance.case_1.explained_1 === true ? 1 : 0, wholeDayAbsence && attendance.case_1.explained_1 === false ? 1 : 0);
      }
      of_tann9x_k$(days) {
        // Inline function 'kotlin.collections.fold' call
        var accumulator = new (BilledDayTotals())();
        var _iterator__ex2g4s = days.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          accumulator = accumulator.plus_8jdhal_k$(Companion_getInstance_18().of_qaxhqt_k$(element));
        }
        return accumulator;
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_25();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_16;
function Companion_getInstance_18() {
  if (Companion_instance_16 === VOID)
    new (Companion_15())();
  return Companion_instance_16;
}
var $serializerClass_14;
function $serializer_14() {
  if ($serializerClass_14 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_14 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.BilledDayTotals', this, 11);
        tmp0_serialDesc.addElement_5pzumi_k$('days', true);
        tmp0_serialDesc.addElement_5pzumi_k$('price', true);
        tmp0_serialDesc.addElement_5pzumi_k$('paidByFamily', true);
        tmp0_serialDesc.addElement_5pzumi_k$('employers', true);
        tmp0_serialDesc.addElement_5pzumi_k$('grants', true);
        tmp0_serialDesc.addElement_5pzumi_k$('regularDays', true);
        tmp0_serialDesc.addElement_5pzumi_k$('intermittentDays', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transportOneWay', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transportTwoWay', true);
        tmp0_serialDesc.addElement_5pzumi_k$('explainedAbsences', true);
        tmp0_serialDesc.addElement_5pzumi_k$('unexplainedAbsences', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_uiw7ti_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_18().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.days_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 0, value.days_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.price_1 === _Cents___init__impl__6gjhxu(0n))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), new (Cents())(value.price_1));
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.paidByFamily_1 === _Cents___init__impl__6gjhxu(0n))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance(), new (Cents())(value.paidByFamily_1));
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.mapOf' call
          var tmp$ret$0 = emptyMap();
          tmp = !equals(value.employers_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.employers_1);
        }
        var tmp_0;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4)) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.mapOf' call
          var tmp$ret$1 = emptyMap();
          tmp_0 = !equals(value.grants_1, tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.grants_1);
        }
        var tmp_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5)) {
          tmp_1 = true;
        } else {
          // Inline function 'kotlin.collections.mapOf' call
          var tmp$ret$2 = emptyMap();
          tmp_1 = !equals(value.regularDays_1, tmp$ret$2);
        }
        if (tmp_1) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, tmp2_cached[5].get_value_j01efc_k$(), value.regularDays_1);
        }
        var tmp_2;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6)) {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.collections.mapOf' call
          var tmp$ret$3 = emptyMap();
          tmp_2 = !equals(value.intermittentDays_1, tmp$ret$3);
        }
        if (tmp_2) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, tmp2_cached[6].get_value_j01efc_k$(), value.intermittentDays_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !(value.transportOneWay_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 7, value.transportOneWay_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8) ? true : !(value.transportTwoWay_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 8, value.transportTwoWay_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 9) ? true : !(value.explainedAbsences_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 9, value.explainedAbsences_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 10) ? true : !(value.unexplainedAbsences_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 10, value.unexplainedAbsences_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_uiw7ti_k$(encoder, value instanceof BilledDayTotals() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = 0;
        var tmp12_local8 = 0;
        var tmp13_local9 = 0;
        var tmp14_local10 = 0;
        var tmp15_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp16_cached = Companion_getInstance_18().$childSerializers_1;
        if (tmp15_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp15_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (Cents())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_2 = $serializer_getInstance();
          var tmp_3 = tmp6_local2;
          var tmp_4 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (Cents())(tmp_3));
          tmp6_local2 = tmp_4 == null ? null : tmp_4.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp16_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp16_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp16_cached[5].get_value_j01efc_k$(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp16_cached[6].get_value_j01efc_k$(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.decodeIntElement_941u6a_k$(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp15_input.decodeIntElement_941u6a_k$(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp15_input.decodeIntElement_941u6a_k$(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp15_input.decodeIntElement_941u6a_k$(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp15_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_5 = $serializer_getInstance();
                var tmp_6 = tmp5_local1;
                var tmp_7 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
                tmp5_local1 = tmp_7 == null ? null : tmp_7.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_8 = $serializer_getInstance();
                var tmp_9 = tmp6_local2;
                var tmp_10 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_8, tmp_9 == null ? null : new (Cents())(tmp_9));
                tmp6_local2 = tmp_10 == null ? null : tmp_10.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp16_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp16_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp16_cached[5].get_value_j01efc_k$(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp16_cached[6].get_value_j01efc_k$(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.decodeIntElement_941u6a_k$(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp15_input.decodeIntElement_941u6a_k$(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp15_input.decodeIntElement_941u6a_k$(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp15_input.decodeIntElement_941u6a_k$(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp15_input.endStructure_1xqz0n_k$(tmp0_desc);
        return BilledDayTotals().new_org_thecommunitygroupinc_cares_BilledDayTotals_gevb62_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_18().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), tmp0_cached[3].get_value_j01efc_k$(), tmp0_cached[4].get_value_j01efc_k$(), tmp0_cached[5].get_value_j01efc_k$(), tmp0_cached[6].get_value_j01efc_k$(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_14 = $;
  }
  return $serializerClass_14;
}
var $serializer_instance_14;
function $serializer_getInstance_25() {
  if ($serializer_instance_14 === VOID)
    new ($serializer_14())();
  return $serializer_instance_14;
}
var BilledDayTotalsClass;
function BilledDayTotals() {
  if (BilledDayTotalsClass === VOID) {
    class $ {
      constructor(days, price, paidByFamily, employers, grants, regularDays, intermittentDays, transportOneWay, transportTwoWay, explainedAbsences, unexplainedAbsences) {
        Companion_getInstance_18();
        days = days === VOID ? 0 : days;
        price = price === VOID ? _Cents___init__impl__6gjhxu(0n) : price;
        paidByFamily = paidByFamily === VOID ? _Cents___init__impl__6gjhxu(0n) : paidByFamily;
        var tmp;
        if (employers === VOID) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp = emptyMap();
        } else {
          tmp = employers;
        }
        employers = tmp;
        var tmp_0;
        if (grants === VOID) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp_0 = emptyMap();
        } else {
          tmp_0 = grants;
        }
        grants = tmp_0;
        var tmp_1;
        if (regularDays === VOID) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp_1 = emptyMap();
        } else {
          tmp_1 = regularDays;
        }
        regularDays = tmp_1;
        var tmp_2;
        if (intermittentDays === VOID) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp_2 = emptyMap();
        } else {
          tmp_2 = intermittentDays;
        }
        intermittentDays = tmp_2;
        transportOneWay = transportOneWay === VOID ? 0 : transportOneWay;
        transportTwoWay = transportTwoWay === VOID ? 0 : transportTwoWay;
        explainedAbsences = explainedAbsences === VOID ? 0 : explainedAbsences;
        unexplainedAbsences = unexplainedAbsences === VOID ? 0 : unexplainedAbsences;
        this.days_1 = days;
        this.price_1 = price;
        this.paidByFamily_1 = paidByFamily;
        this.employers_1 = employers;
        this.grants_1 = grants;
        this.regularDays_1 = regularDays;
        this.intermittentDays_1 = intermittentDays;
        this.transportOneWay_1 = transportOneWay;
        this.transportTwoWay_1 = transportTwoWay;
        this.explainedAbsences_1 = explainedAbsences;
        this.unexplainedAbsences_1 = unexplainedAbsences;
      }
      get_totalContributions_2d9vkp_k$() {
        return Cents__minus_impl_j8lyu0(this.price_1, this.paidByFamily_1);
      }
      plus_8jdhal_k$(other) {
        var tmp = this.days_1 + other.days_1 | 0;
        var tmp_0 = Cents__plus_impl_qsv4s8(this.price_1, other.price_1);
        var tmp_1 = Cents__plus_impl_qsv4s8(this.paidByFamily_1, other.paidByFamily_1);
        // Inline function 'kotlin.collections.associateWith' call
        var this_0 = plus(this.employers_1.get_keys_wop4xp_k$(), other.employers_1.get_keys_wop4xp_k$());
        var result = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
        // Inline function 'kotlin.collections.associateWithTo' call
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var it = element.raw_1;
          var tmp0_elvis_lhs = this.employers_1.get_wei43m_k$(new (ID_0())(it));
          var tmp_2 = tmp0_elvis_lhs == null ? new (PayerTotal())() : tmp0_elvis_lhs;
          var tmp1_elvis_lhs = other.employers_1.get_wei43m_k$(new (ID_0())(it));
          var tmp$ret$2 = tmp_2.plus_3a1o0x_k$(tmp1_elvis_lhs == null ? new (PayerTotal())() : tmp1_elvis_lhs);
          result.put_4fpzoq_k$(element, tmp$ret$2);
        }
        var tmp_3 = result;
        // Inline function 'kotlin.collections.associateWith' call
        var this_1 = plus(this.grants_1.get_keys_wop4xp_k$(), other.grants_1.get_keys_wop4xp_k$());
        var result_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16));
        // Inline function 'kotlin.collections.associateWithTo' call
        var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          var it_0 = element_0.raw_1;
          var tmp0_elvis_lhs_0 = this.grants_1.get_wei43m_k$(new (ID())(it_0));
          var tmp_4 = tmp0_elvis_lhs_0 == null ? new (PayerTotal())() : tmp0_elvis_lhs_0;
          var tmp1_elvis_lhs_0 = other.grants_1.get_wei43m_k$(new (ID())(it_0));
          var tmp$ret$5 = tmp_4.plus_3a1o0x_k$(tmp1_elvis_lhs_0 == null ? new (PayerTotal())() : tmp1_elvis_lhs_0);
          result_0.put_4fpzoq_k$(element_0, tmp$ret$5);
        }
        var tmp_5 = result_0;
        // Inline function 'kotlin.collections.associateWith' call
        var this_2 = plus(this.regularDays_1.get_keys_wop4xp_k$(), other.regularDays_1.get_keys_wop4xp_k$());
        var result_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16));
        // Inline function 'kotlin.collections.associateWithTo' call
        var _iterator__ex2g4s_1 = this_2.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
          var tmp0_elvis_lhs_1 = this.regularDays_1.get_wei43m_k$(element_1);
          var tmp_6 = tmp0_elvis_lhs_1 == null ? 0 : tmp0_elvis_lhs_1;
          var tmp1_elvis_lhs_1 = other.regularDays_1.get_wei43m_k$(element_1);
          var tmp$ret$8 = tmp_6 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
          result_1.put_4fpzoq_k$(element_1, tmp$ret$8);
        }
        var tmp_7 = result_1;
        // Inline function 'kotlin.collections.associateWith' call
        var this_3 = plus(this.intermittentDays_1.get_keys_wop4xp_k$(), other.intermittentDays_1.get_keys_wop4xp_k$());
        var result_2 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_3, 10)), 16));
        // Inline function 'kotlin.collections.associateWithTo' call
        var _iterator__ex2g4s_2 = this_3.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
          var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
          var tmp0_elvis_lhs_2 = this.intermittentDays_1.get_wei43m_k$(element_2);
          var tmp_8 = tmp0_elvis_lhs_2 == null ? 0 : tmp0_elvis_lhs_2;
          var tmp1_elvis_lhs_2 = other.intermittentDays_1.get_wei43m_k$(element_2);
          var tmp$ret$11 = tmp_8 + (tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2) | 0;
          result_2.put_4fpzoq_k$(element_2, tmp$ret$11);
        }
        return new (BilledDayTotals())(tmp, tmp_0, tmp_1, tmp_3, tmp_5, tmp_7, result_2, this.transportOneWay_1 + other.transportOneWay_1 | 0, this.transportTwoWay_1 + other.transportTwoWay_1 | 0, this.explainedAbsences_1 + other.explainedAbsences_1 | 0, this.unexplainedAbsences_1 + other.unexplainedAbsences_1 | 0);
      }
      toString() {
        return 'BilledDayTotals(days=' + this.days_1 + ', price=' + Cents__toString_impl_ko5hxm(this.price_1) + ', paidByFamily=' + Cents__toString_impl_ko5hxm(this.paidByFamily_1) + ', employers=' + toString(this.employers_1) + ', grants=' + toString(this.grants_1) + ', regularDays=' + toString(this.regularDays_1) + ', intermittentDays=' + toString(this.intermittentDays_1) + ', transportOneWay=' + this.transportOneWay_1 + ', transportTwoWay=' + this.transportTwoWay_1 + ', explainedAbsences=' + this.explainedAbsences_1 + ', unexplainedAbsences=' + this.unexplainedAbsences_1 + ')';
      }
      hashCode() {
        var result = this.days_1;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.price_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.paidByFamily_1) | 0;
        result = imul(result, 31) + hashCode(this.employers_1) | 0;
        result = imul(result, 31) + hashCode(this.grants_1) | 0;
        result = imul(result, 31) + hashCode(this.regularDays_1) | 0;
        result = imul(result, 31) + hashCode(this.intermittentDays_1) | 0;
        result = imul(result, 31) + this.transportOneWay_1 | 0;
        result = imul(result, 31) + this.transportTwoWay_1 | 0;
        result = imul(result, 31) + this.explainedAbsences_1 | 0;
        result = imul(result, 31) + this.unexplainedAbsences_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BilledDayTotals()))
          return false;
        if (!(this.days_1 === other.days_1))
          return false;
        if (!(this.price_1 === other.price_1))
          return false;
        if (!(this.paidByFamily_1 === other.paidByFamily_1))
          return false;
        if (!equals(this.employers_1, other.employers_1))
          return false;
        if (!equals(this.grants_1, other.grants_1))
          return false;
        if (!equals(this.regularDays_1, other.regularDays_1))
          return false;
        if (!equals(this.intermittentDays_1, other.intermittentDays_1))
          return false;
        if (!(this.transportOneWay_1 === other.transportOneWay_1))
          return false;
        if (!(this.transportTwoWay_1 === other.transportTwoWay_1))
          return false;
        if (!(this.explainedAbsences_1 === other.explainedAbsences_1))
          return false;
        if (!(this.unexplainedAbsences_1 === other.unexplainedAbsences_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_BilledDayTotals_gevb62_k$(seen0, days, price, paidByFamily, employers, grants, regularDays, intermittentDays, transportOneWay, transportTwoWay, explainedAbsences, unexplainedAbsences, serializationConstructorMarker) {
        Companion_getInstance_18();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_25().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.days_1 = 0;
        else
          $this.days_1 = days;
        if (0 === (seen0 & 2))
          $this.price_1 = _Cents___init__impl__6gjhxu(0n);
        else
          $this.price_1 = price;
        if (0 === (seen0 & 4))
          $this.paidByFamily_1 = _Cents___init__impl__6gjhxu(0n);
        else
          $this.paidByFamily_1 = paidByFamily;
        if (0 === (seen0 & 8)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.mapOf' call
          tmp.employers_1 = emptyMap();
        } else
          $this.employers_1 = employers;
        if (0 === (seen0 & 16)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.mapOf' call
          tmp_0.grants_1 = emptyMap();
        } else
          $this.grants_1 = grants;
        if (0 === (seen0 & 32)) {
          var tmp_1 = $this;
          // Inline function 'kotlin.collections.mapOf' call
          tmp_1.regularDays_1 = emptyMap();
        } else
          $this.regularDays_1 = regularDays;
        if (0 === (seen0 & 64)) {
          var tmp_2 = $this;
          // Inline function 'kotlin.collections.mapOf' call
          tmp_2.intermittentDays_1 = emptyMap();
        } else
          $this.intermittentDays_1 = intermittentDays;
        if (0 === (seen0 & 128))
          $this.transportOneWay_1 = 0;
        else
          $this.transportOneWay_1 = transportOneWay;
        if (0 === (seen0 & 256))
          $this.transportTwoWay_1 = 0;
        else
          $this.transportTwoWay_1 = transportTwoWay;
        if (0 === (seen0 & 512))
          $this.explainedAbsences_1 = 0;
        else
          $this.explainedAbsences_1 = explainedAbsences;
        if (0 === (seen0 & 1024))
          $this.unexplainedAbsences_1 = 0;
        else
          $this.unexplainedAbsences_1 = unexplainedAbsences;
        return $this;
      }
    }
    initMetadataForClass($, 'BilledDayTotals', BilledDayTotals, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_25});
    BilledDayTotalsClass = $;
  }
  return BilledDayTotalsClass;
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_17;
function Companion_getInstance_19() {
  return Companion_instance_17;
}
var $serializerClass_15;
function $serializer_15() {
  if ($serializerClass_15 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_15 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.PayerTotal', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('days', true);
        tmp0_serialDesc.addElement_5pzumi_k$('amount', true);
        tmp0_serialDesc.addElement_5pzumi_k$('administrativeCharge', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_yl52v8_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.days_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 0, value.days_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.amount_1 === _Cents___init__impl__6gjhxu(0n))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), new (Cents())(value.amount_1));
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.administrativeCharge_1 === _Cents___init__impl__6gjhxu(0n))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance(), new (Cents())(value.administrativeCharge_1));
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_yl52v8_k$(encoder, value instanceof PayerTotal() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (Cents())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_2 = $serializer_getInstance();
          var tmp_3 = tmp6_local2;
          var tmp_4 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (Cents())(tmp_3));
          tmp6_local2 = tmp_4 == null ? null : tmp_4.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_5 = $serializer_getInstance();
                var tmp_6 = tmp5_local1;
                var tmp_7 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
                tmp5_local1 = tmp_7 == null ? null : tmp_7.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_8 = $serializer_getInstance();
                var tmp_9 = tmp6_local2;
                var tmp_10 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_8, tmp_9 == null ? null : new (Cents())(tmp_9));
                tmp6_local2 = tmp_10 == null ? null : tmp_10.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return PayerTotal().new_org_thecommunitygroupinc_cares_PayerTotal_ljr5kh_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance(), $serializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_15 = $;
  }
  return $serializerClass_15;
}
var $serializer_instance_15;
function $serializer_getInstance_26() {
  if ($serializer_instance_15 === VOID)
    new ($serializer_15())();
  return $serializer_instance_15;
}
var PayerTotalClass;
function PayerTotal() {
  if (PayerTotalClass === VOID) {
    class $ {
      constructor(days, amount, administrativeCharge) {
        days = days === VOID ? 0 : days;
        amount = amount === VOID ? _Cents___init__impl__6gjhxu(0n) : amount;
        administrativeCharge = administrativeCharge === VOID ? _Cents___init__impl__6gjhxu(0n) : administrativeCharge;
        this.days_1 = days;
        this.amount_1 = amount;
        this.administrativeCharge_1 = administrativeCharge;
      }
      plus_3a1o0x_k$(other) {
        return new (PayerTotal())(this.days_1 + other.days_1 | 0, Cents__plus_impl_qsv4s8(this.amount_1, other.amount_1), Cents__plus_impl_qsv4s8(this.administrativeCharge_1, other.administrativeCharge_1));
      }
      toString() {
        return 'PayerTotal(days=' + this.days_1 + ', amount=' + Cents__toString_impl_ko5hxm(this.amount_1) + ', administrativeCharge=' + Cents__toString_impl_ko5hxm(this.administrativeCharge_1) + ')';
      }
      hashCode() {
        var result = this.days_1;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.amount_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.administrativeCharge_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayerTotal()))
          return false;
        if (!(this.days_1 === other.days_1))
          return false;
        if (!(this.amount_1 === other.amount_1))
          return false;
        if (!(this.administrativeCharge_1 === other.administrativeCharge_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_PayerTotal_ljr5kh_k$(seen0, days, amount, administrativeCharge, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_26().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.days_1 = 0;
        else
          $this.days_1 = days;
        if (0 === (seen0 & 2))
          $this.amount_1 = _Cents___init__impl__6gjhxu(0n);
        else
          $this.amount_1 = amount;
        if (0 === (seen0 & 4))
          $this.administrativeCharge_1 = _Cents___init__impl__6gjhxu(0n);
        else
          $this.administrativeCharge_1 = administrativeCharge;
        return $this;
      }
    }
    initMetadataForClass($, 'PayerTotal', PayerTotal, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_26});
    PayerTotalClass = $;
  }
  return PayerTotalClass;
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_18;
function Companion_getInstance_20() {
  return Companion_instance_18;
}
var $serializerClass_16;
function $serializer_16() {
  if ($serializerClass_16 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_16 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.RemittanceProblem', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('placement', false);
        tmp0_serialDesc.addElement_5pzumi_k$('childName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('location', false);
        tmp0_serialDesc.addElement_5pzumi_k$('message', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_7oz7xi_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_2(), new (ID_1())(value.placement_1));
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.childName_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_4(), new (ID_3())(value.location_1));
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.message_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_7oz7xi_k$(encoder, value instanceof RemittanceProblem() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_1())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_2 = $serializer_getInstance_4();
          var tmp_3 = tmp6_local2;
          var tmp_4 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (ID_3())(tmp_3));
          tmp6_local2 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_5 = $serializer_getInstance_2();
                var tmp_6 = tmp4_local0;
                var tmp_7 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new (ID_1())(tmp_6));
                tmp4_local0 = tmp_7 == null ? null : tmp_7.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_8 = $serializer_getInstance_4();
                var tmp_9 = tmp6_local2;
                var tmp_10 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_8, tmp_9 == null ? null : new (ID_3())(tmp_9));
                tmp6_local2 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return RemittanceProblem().new_org_thecommunitygroupinc_cares_RemittanceProblem_l3db0_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_2(), StringSerializer_getInstance(), $serializer_getInstance_4(), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_16 = $;
  }
  return $serializerClass_16;
}
var $serializer_instance_16;
function $serializer_getInstance_27() {
  if ($serializer_instance_16 === VOID)
    new ($serializer_16())();
  return $serializer_instance_16;
}
var RemittanceProblemClass;
function RemittanceProblem() {
  if (RemittanceProblemClass === VOID) {
    class $ {
      constructor(placement, childName, location, message) {
        this.placement_1 = placement;
        this.childName_1 = childName;
        this.location_1 = location;
        this.message_1 = message;
      }
      toString() {
        return 'RemittanceProblem(placement=' + ID__toString_impl_y5caka_1(this.placement_1) + ', childName=' + this.childName_1 + ', location=' + ID__toString_impl_y5caka_3(this.location_1) + ', message=' + this.message_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_1(this.placement_1);
        result = imul(result, 31) + getStringHashCode(this.childName_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_3(this.location_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.message_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RemittanceProblem()))
          return false;
        if (!equals(this.placement_1, other.placement_1))
          return false;
        if (!(this.childName_1 === other.childName_1))
          return false;
        if (!equals(this.location_1, other.location_1))
          return false;
        if (!(this.message_1 === other.message_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_RemittanceProblem_l3db0_k$(seen0, placement, childName, location, message, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_27().descriptor_1);
        }
        var $this = createThis(this);
        $this.placement_1 = placement;
        $this.childName_1 = childName;
        $this.location_1 = location;
        $this.message_1 = message;
        return $this;
      }
    }
    initMetadataForClass($, 'RemittanceProblem', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_27});
    RemittanceProblemClass = $;
  }
  return RemittanceProblemClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
Companion_instance_1 = new (Companion_0())();
Companion_instance_2 = new (Companion_1())();
Companion_instance_3 = new (Companion_2())();
Companion_instance_4 = new (Companion_3())();
Companion_instance_5 = new (Companion_4())();
Companion_instance_6 = new (Companion_5())();
Companion_instance_7 = new (Companion_6())();
Companion_instance_9 = new (Companion_8())();
Companion_instance_10 = new (Companion_9())();
Companion_instance_11 = new (Companion_10())();
Companion_instance_15 = new (Companion_14())();
Companion_instance_17 = new (Companion_16())();
Companion_instance_18 = new (Companion_17())();
//endregion
//region block: exports
export {
  $serializer_getInstance_12 as $serializer_getInstancez3cztbuzvhxy,
  Companion_instance_2 as Companion_instance3cnh73pq3p9e,
  $serializer_getInstance_11 as $serializer_getInstancez3kimx5dzjz3,
  Companion_instance_1 as Companion_instanceka5seqar5yvk,
  Companion_instance_0 as Companion_instancelmyt635fcx9j,
  Companion_getInstance_18 as Companion_getInstance2uuaiykt2g0g3,
  Companion_getInstance_15 as Companion_getInstance1ytzay7iyj05v,
  Companion_instance_7 as Companion_instance228e8j20cxdzg,
  Companion_getInstance_10 as Companion_getInstanceafwi4dr4nsgt,
  Companion_getInstance_14 as Companion_getInstance2ufvbwwa42es2,
  Companion_instance_11 as Companion_instance1zp2bd525ftuh,
  Companion_instance_10 as Companion_instance1rfwfy6nwd43q,
  Companion_instance_9 as Companion_instance10dn71lg9ig3t,
  Companion_instance_6 as Companion_instance3rsay32qgy1xl,
  Companion_instance_5 as Companion_instance2ukmb1iai6ee6,
  Companion_instance_4 as Companion_instance1d8b451omsiul,
  Companion_instance_3 as Companion_instance3px40qt4y9hbg,
  Companion_getInstance_16 as Companion_getInstance3sc92273t9rvh,
  Companion_instance_15 as Companion_instance3fp35l9mm3c9t,
  BilledDayTotals as BilledDayTotals2enuwcjtkow7,
  ID_9 as ID1sgzzdpfpwkrm,
  get_entries as get_entries2njiymqynk3u0,
  EmployerContribution as EmployerContribution22em0kfok1nyo,
  GrantContribution as GrantContribution17s6i04gc835s,
  ID_8 as ID2pi5mto15i7f6,
  SingleChildDay as SingleChildDayfsi906tc8dp6,
  CareProviderRemittance as CareProviderRemittances9omflxtwvni,
  EmployerAccountTransaction as EmployerAccountTransaction2xx9wct21t09o,
  GrantAccountTransaction as GrantAccountTransaction19one3d48lc6r,
  PayerTotal as PayerTotal162ou2gf96d2t,
  ProviderPeriod as ProviderPeriod3npnb7yy6xoeh,
};
//endregion

//# sourceMappingURL=money.mjs.map
